// Estilos do componente principal de circuito/index.js (composição de
// FormularioTab/AnexosTab/DiagramaTab + seção "Observações Finais") e do
// componente compartilhado ModalEditCheckbox, que também vive na raiz de
// circuito/ — os demais estilos foram distribuídos para os styles.js de cada
// subpasta na Task 6 da decomposição.
const styles = () => ({
	modalEditCheckbox: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	paperModalEditCheckBoxLabel: {
		display: "flex",
		flexDirection: "column",
		gap: 1,
		p: 1,
		borderRadius: 2,
		maxHeight: "30vh",
		position: "relative",
		pt: 0,
	},
	boxHandlerButtons: {
		display: "flex",
		flexDirection: "row",
		gap: 1,
		alignItems: "center",
		justifyContent: "flex-end",
		mt: 1,
	},
	textField: {
		fontSize: "0.96rem", // diminui fonte geral
		"& .MuiInputBase-input": {
			padding: "6px 8px", // padding interno reduzido
			fontSize: "0.96rem", // fonte do input
		},
		"& .MuiInputLabel-root": {
			fontSize: "0.96rem", // fonte da label
		},
	},
	gritItemTitle: {
		display: "flex",
		alignItems: "center",
		gap: 1,
		flexDirection: "row",
		width: "100%",
	},
	contentIdentation: {
		pl: 5,
		pt: 2,
	},
});

export default styles;
